import { render, staticRenderFns } from "./Lgx315088047483912192.vue?vue&type=template&id=10dae208&scoped=true&"
import script from "./Lgx315088047483912192.vue?vue&type=script&lang=js&"
export * from "./Lgx315088047483912192.vue?vue&type=script&lang=js&"
import style0 from "./Lgx315088047483912192.vue?vue&type=style&index=0&id=10dae208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dae208",
  null
  
)

export default component.exports